"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessPercent = BusinessPercent;
exports.BusinessProfitAvePast3YearsAmount = BusinessProfitAvePast3YearsAmount;
exports.NetBookValueAmount = NetBookValueAmount;
exports.NonserviceBusinessRadioButton = NonserviceBusinessRadioButton;
exports.OwnersAveSalaryPast3YearsAmount = OwnersAveSalaryPast3YearsAmount;
exports.ServiceBusinessRadioButton = ServiceBusinessRadioButton;
exports.businessShareFormulaNonService = businessShareFormulaNonService;
exports.businessShareFormulaService = businessShareFormulaService;
exports.totalBusinessValNonService = totalBusinessValNonService;
exports.totalBusinessValService = totalBusinessValService;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _utils = require("../../middleware/utils");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _BusinessValuationWizardCalc = require("./BusinessValuationWizardCalc.config");
var _TextInputForForm = require("../Wizard/TextInputForForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function OwnersAveSalaryPast3YearsAmount(_ref) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref;
  var fieldName = 'ownersAvePrior3YearsAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var label = "Average owner's salary for the past three years";
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function BusinessProfitAvePast3YearsAmount(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'businessProfitAvePrior3YearsAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var label = 'Average annual profit for the past three years';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function NetBookValueAmount(_ref3) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'netBookAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var label = 'Net Book Value';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function BusinessPercent(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'businessPercent';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = '00.00';
  var label = 'Your Percentage';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: label,
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function ServiceBusinessRadioButton(props) {
  var {
    setFieldValue,
    isService
  } = props;
  var fieldName = 'serviceRadioButton';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_BusinessValuationWizardCalc.calcName, 'field_input', fieldName, 'service');
      setFieldValue('isService', 'service');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    "aria-label": "Service",
    id: "serviceRadioBtn",
    name: "customRadio",
    className: "custom-control-input",
    required: true,
    checked: isService === 'service'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "serviceRadioBtn"
  }, "Service"))), /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: fieldName,
    text: _BusinessValuationWizardCalc.popoverConfig.serviceText
  })));
}
function NonserviceBusinessRadioButton(props) {
  var {
    setFieldValue,
    isService
  } = props;
  var fieldName = 'nonServiceRadioButton';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-btn-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-radio flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_BusinessValuationWizardCalc.calcName, 'field_input', fieldName, 'nonservice');
      setFieldValue('isService', 'nonservice');
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "radio-group",
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    "aria-label": "Non-Service",
    id: "nonServiceRadioBtn",
    name: "customRadio",
    className: "custom-control-input",
    required: true,
    checked: isService === 'nonservice'
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "nonServiceRadioBtn"
  }, "Non-Service"))), /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: fieldName,
    text: _BusinessValuationWizardCalc.popoverConfig.nonServiceText
  })));
}

// Formula if "Service" is chosen on screen 1
function businessShareFormulaService(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount, businessPercent) {
  return (0, _utils.numberToCurrencyString)(Math.round(((parseFloat(ownersAvePrior3YearsAmount.replace(/,/g, '')) + parseFloat(businessProfitAvePrior3YearsAmount.replace(/,/g, ''))) * 2 + parseFloat(netBookAmount.replace(/,/g, ''))) * (parseFloat(businessPercent) / 100)));
}

// Formula if "Non-Service" is chosen on screen 1
function businessShareFormulaNonService(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount, businessPercent) {
  return (0, _utils.numberToCurrencyString)(Math.round(((parseFloat(ownersAvePrior3YearsAmount.replace(/,/g, '')) + parseFloat(businessProfitAvePrior3YearsAmount.replace(/,/g, ''))) * 2.875 + parseFloat(netBookAmount.replace(/,/g, ''))) * (parseFloat(businessPercent) / 100)));
}

// Formula if "Service" is chosen on screen 1:
function totalBusinessValService(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount) {
  return (0, _utils.numberToCurrencyString)(Math.round((parseFloat(ownersAvePrior3YearsAmount.replace(/,/g, '')) + parseFloat(businessProfitAvePrior3YearsAmount.replace(/,/g, ''))) * 2 + parseFloat(netBookAmount.replace(/,/g, ''))));
}

// Formula if "Non-Service" is chosen on screen 1:
function totalBusinessValNonService(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount) {
  return (0, _utils.numberToCurrencyString)(Math.round((parseFloat(ownersAvePrior3YearsAmount.replace(/,/g, '')) + parseFloat(businessProfitAvePrior3YearsAmount.replace(/,/g, ''))) * 2.875 + parseFloat(netBookAmount.replace(/,/g, ''))));
}